import { RestApiClient } from "../../../../Scripts/inpulse/RestApiClient";

export class FeedbackApiService {
    constructor(
        private client: RestApiClient,
    ) {
        //api/feedback
    }

    //MyContacts(): ICallbackResult {
    //    var method = "mycontacts";
    //    return this.client.get<DataTablesResult<ContactRow>>(method);
    //}

    MyNewMessagesCount(): Promise<number> {
        var method = "mynewmessagescount";
        return this.client.get<number>(method);
    }
}



//import { IAjaxCallerTs } from "../../../../Scripts/Default/AjaxCallerTsImplementation/AjaxCaller";
//import { ICallbackResult } from "../../../../Scripts/Default/AjaxCallerTsImplementation/CallBackObject";

//export class FeedbackApiService {
//    constructor(
//        private client: IAjaxCallerTs,
//    ) {
//    }

//    Mycontacts(): ICallbackResult {
//        var method = "mycontacts";
//        return this.client.execute(method, null);
//    }

//    MyNewMessagesCount(): ICallbackResult {
//        var method = "mynewmessagescount";
//        return this.client.execute(method, null);
//    }
//}